import Fuse from "fuse.js";

import BaseAutoCompleteSelect from "features/shared/components/form/components/autoCompleteSelect/baseAutoCompleteSelect";
import { StringSelectionValue } from "features/shared/types/select";
import { useSelector } from "services/redux/rootReducer";

interface Props {
    name: string;
    value?: string;
    onChangeHandler: (
        name: string,
        value: StringSelectionValue["value"]
    ) => void;
}

const AutoCompleteArticleId: React.FC<Props> = ({
    name,
    value,
    onChangeHandler,
}) => {
    const articles = useSelector((state) => state.articles);

    const queriedSelectionValues: StringSelectionValue[] = articles.map(
        (article) => ({
            display: `${article.properties.name?.en ?? "(No name)"} (${
                article.id
            })`,
            value: article.id,
        })
    );

    const articleFilterSorter = (
        searchValue: string,
        initialValues: StringSelectionValue[]
    ) => {
        console.log(searchValue, initialValues);
        const fuse = new Fuse(initialValues, {
            threshold: 0.2,
            keys: ["display"],
        });
        const results = fuse
            .search(searchValue)
            .map((result) => result.item)
            .sort((a, b) => {
                if (a.display < b.display) return -1;
                if (a.display > b.display) return 1;
                return 0;
            });

        return results;
    };

    return (
        <BaseAutoCompleteSelect
            queriedSelectionValues={queriedSelectionValues}
            filterSorterFunction={articleFilterSorter}
            onChangeHandler={onChangeHandler}
            name={name}
            value={value ?? ""}
        />
    );
};

export default AutoCompleteArticleId;
